import styled, { css } from 'styled-components';
import { Text, spacing } from '@landr/maestro';

const titleBaseStyles = css`
    display: block;
    width: 100%;
    white-space: break-space;
    text-overflow: ellipsis;
    overflow: hidden;
    min-height: ${spacing('lg')};
`;

export const Byline = styled(Text)`
    ${titleBaseStyles};
`;
